import React from 'react';
import { Link } from 'react-router-dom';
import { ScaleIcon, MailIcon, PhoneIcon, ClockIcon, FacebookIcon, InstagramIcon, LinkedinIcon, YoutubeIcon, AtSignIcon } from 'lucide-react';
const socials = [{
  icon: FacebookIcon,
  href: 'https://www.facebook.com/andreea.saveli',
  label: 'Facebook'
}, {
  icon: InstagramIcon,
  href: 'https://www.instagram.com/andreeasaveli/',
  label: 'Instagram'
}, {
  icon: AtSignIcon,
  href: 'https://www.threads.com/@andreeasaveli',
  label: 'Threads'
}, {
  icon: LinkedinIcon,
  href: 'https://www.linkedin.com/search/results/all/?keywords=Andreea%20saveli&origin=GLOBAL_SEARCH_HEADER',
  label: 'LinkedIn'
}, {
  icon: YoutubeIcon,
  href: 'https://www.youtube.com/@andreeasaveli',
  label: 'YouTube'
}];
export function Footer() {
  return <footer id="contact" className="bg-navy py-12 px-6 border-t border-gold/20" data-id="element-47">
      <div className="max-w-7xl mx-auto" data-id="element-48">
        <div className="grid md:grid-cols-3 gap-12 mb-8" data-id="element-49">
          <div data-id="element-50">
            <div className="flex items-center gap-3 mb-4" data-id="element-51">
              <ScaleIcon className="w-8 h-8 text-gold" strokeWidth={1.5} data-id="element-52" />
              <div data-id="element-53">
                <div className="text-text-light font-heading text-xl font-bold" data-id="element-54">
                  Andreea Saveli
                </div>
                <div className="text-gold text-[10px] font-label uppercase tracking-label" data-id="element-55">
                  Avocat Dreptul Familiei
                </div>
              </div>
            </div>
            <p className="text-text-light-secondary font-body text-sm leading-relaxed" data-id="element-56">
              Avocat Dreptul Familiei · Divorț · Partaj · Moșteniri. 23 de ani
              de experiență în cele mai dificile situații de familie.
            </p>
          </div>

          <div data-id="element-57">
            <h3 className="text-text-light font-label text-sm uppercase tracking-label mb-4" data-id="element-58">
              Contact
            </h3>
            <div className="space-y-3" data-id="element-59">
              <a href="tel:+40726719788" className="flex items-center gap-2 text-text-light-secondary hover:text-gold transition-colors font-body text-sm" data-id="element-60">
                <PhoneIcon className="w-4 h-4" strokeWidth={1.5} data-id="element-61" />
                +40 726 719 788
              </a>
              <a href="mailto:office@asistenta-juridica.ro" className="flex items-center gap-2 text-text-light-secondary hover:text-gold transition-colors font-body text-sm" data-id="element-62">
                <MailIcon className="w-4 h-4" strokeWidth={1.5} data-id="element-63" />
                office@asistenta-juridica.ro
              </a>
              <p className="flex items-center gap-2 text-text-light-secondary font-body text-sm" data-id="element-64">
                <ClockIcon className="w-4 h-4" strokeWidth={1.5} data-id="element-65" />
                Luni – Vineri, 08:00 – 18:00
              </p>
            </div>
          </div>

          <div data-id="element-66">
            <h3 className="text-text-light font-label text-sm uppercase tracking-label mb-4" data-id="element-67">
              Urmărește-mă
            </h3>
            <div className="flex flex-wrap gap-4 mb-6" data-id="element-68">
              {socials.map(s => <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="text-text-light-secondary hover:text-gold transition-colors" data-id="element-69">
                  <s.icon className="w-5 h-5" strokeWidth={1.5} data-id="element-70" />
                </a>)}
            </div>
            <Link to="/contact" className="inline-block border-[1.5px] border-gold text-gold px-6 py-2.5 rounded font-label text-xs uppercase tracking-label hover:bg-gold/10 transition-colors" data-id="element-71">
              Rezervă o Sesiune
            </Link>
          </div>
        </div>

        <div className="border-t border-gold/20 pt-8 text-center" data-id="element-72">
          <p className="text-text-light-secondary font-body text-sm" data-id="element-73">
            © {new Date().getFullYear()} Andreea Saveli. Toate drepturile
            rezervate.
          </p>
        </div>
      </div>
    </footer>;
}